/* tslint:disable */
/* eslint-disable */
/**
 * Optimizely Feature Experimentation API
 * This page documents how to use the Optimizely FX API. With this API you can view and manage Feature Flags and all of their related entities including Variables, Variations, Rules, and Reports.  The base URL is https://api.optimizely.com/flags/v1. Append any paths listed in these docs onto that url in order to make requests to the API.
 *
 * The version of the OpenAPI document: 0.3.7
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Group,
    GroupFromJSON,
    GroupFromJSONTyped,
    GroupToJSON,
} from './';

/**
 * Map of groups that include group id as key and group payload as value.
 * @export
 * @interface GroupMap
 */
export interface GroupMap {
    [key: string]: Group;
}

export function GroupMapFromJSON(json: any): GroupMap {
    return GroupMapFromJSONTyped(json, false);
}

export function GroupMapFromJSONTyped(json: any, ignoreDiscriminator: boolean): GroupMap {
    return json;
}

export function GroupMapToJSON(value?: GroupMap | null): any {
    return value;
}


